const apis = () => {
  const local = "https://marketing.hafizbrothersestate.com/";
  const localServer = "http://localhost:8081/";
  const list = {
    register: `${local}user/register`,
    login: `${local}user/login`,
    addContact: `${local}/admin/contact/add`,
    assignContact: `${local}admin/contact/assign`,
    startCall: `${local}user/call/start`,
    endCall: `${local}user/call/end`,
    getContacts: `${local}user/contact/list`,
    getSingleContactHis: `${local}user/contact/history`,
    getUserList: `${local}admin/user/list`,
    getPendingWrapup: `${local}user/contact/wrapup/pending`,
  };
  return list;
};
export default apis;
